import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center">
      {/* Background Image with Overlay */}
      <motion.div 
        className="absolute inset-0"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
        <img
          src="https://images.unsplash.com/photo-1629909613654-28e377c37b09?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2088&q=80"
          alt="Dental Clinic"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      </motion.div>

      {/* Content */}
      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h1 
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 text-[#f9e1ec] cursor-pointer font-serif italic tracking-wide"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          AURADENT
        </motion.h1>
        <motion.p 
          className="text-lg sm:text-xl md:text-2xl text-gray-200 mb-6 sm:mb-8 px-4 sm:px-0"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Professional Dental & Facial Aesthetics Services for Your Health and Beauty
        </motion.p>
        <motion.div 
          className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6 px-4 sm:px-0"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <ScrollLink
            to="contact"
            smooth={true}
            duration={500}
            className="w-full sm:w-auto text-center bg-[#FD5DA8] text-white px-6 sm:px-8 py-3 rounded-full hover:bg-[#FD5DA8]/90 transition-all duration-300 hover:scale-105 cursor-pointer"
          >
            Book Appointment
          </ScrollLink>
          <ScrollLink
            to="services"
            smooth={true}
            duration={500}
            className="w-full sm:w-auto text-center bg-white text-black px-6 sm:px-8 py-3 rounded-full hover:bg-[#FD5DA8] transition-all duration-300 hover:scale-105 cursor-pointer"
          >
            Our Services
          </ScrollLink>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero; 